import { CallbackIcon } from "../../utils/svgIcons";
import "../styles.scss";
const FloatingButtonCTA = ({ handleCtaClick }) => {
  return (
    <button className="domain__landing--floating-cta" onClick={handleCtaClick}>
      <CallbackIcon />
    </button>
  );
};

export default FloatingButtonCTA;
